import * as React from "react";

import useBridgeClient from "src/common/hooks/BridgeSWRClient";
import { endpoint } from "src/lib/bridgeClient";
import useStore from "src/store/store";

export class Org {
  data: MyOrg;
  checks: MyOrgValid;

  constructor(data: MyOrg, checks: MyOrgValid) {
    this.data = data;
    this.checks = checks;
  }

  id(): number {
    return this.data.id;
  }

  name(): string {
    return this.data.name;
  }

  blockWorkflowCreation(): boolean {
    return !this.checks.valid;
  }

  actionNeeded() {
    return {
      invalidCredentials: !this.checks.aws.access,
      invalidNetwork: !this.checks.aws.network,
    };
  }

  ssoEnabled(): boolean {
    if (this.data.sso == true) {
      return true;
    }

    return false;
  }
}

export const useGetMyOrg = () => {
  const config = useStore((state) => state.clientConfig);
  const validCreds = useStore((state) => state.valid);

  const dispatch = validCreds() && config?.bapiURL;
  const { data, error } = useBridgeClient<MyOrg>(dispatch ? endpoint.myOrg : null);

  const { data: checks } = useBridgeClient<MyOrgValid>(dispatch ? endpoint.myOrgValid : null);

  const org = React.useMemo(() => {
    if (data && checks) {
      return new Org(data, checks);
    }
  }, [data, checks]);

  return { data: org, error };
};
